import i18n from '@/plugins/i18n';

const CHASSIS = 'Chassis';
const TRAILER_TYPES = ['Container', 'ContainerReefer', 'DryVan', 'DryVanReefer', 'Flatbed'];

function mapObservationData(observation) {
  const chassis = observation.assetObservations?.find(assetObservation =>
    assetObservation.assetType?.includes(CHASSIS)
  );

  const trailer = observation.assetObservations?.find(assetObservation =>
    TRAILER_TYPES.includes(assetObservation.assetType)
  );

  return {
    ...observation,
    date: observation.detectedAt,
    time: observation.detectedAt,
    vehicle: {
      licensePlate: observation.licensePlate || '-',
      number: observation.number || '-',
      carrier: observation.carrierName || '-',
      dotNumber: observation.dotNumber || '-',
      class: observation.vehicleClass || '-',
      fuelType: observation.fuelType || 'Diesel',
      damage: observation.damage
        ? i18n.global.t('gateFeed.messages.pleaseSelectAWarehouseFirst')
        : 'No'
    },
    chassis: {
      licensePlate: chassis?.licensePlate || '-',
      number: chassis?.number || '-',
      damage: chassis?.damage
        ? i18n.global.t('gateFeed.lists.observationList.hasDamage')
        : i18n.global.t('gateFeed.lists.observationList.noDamage'),
      detectedAt: observation?.detectedAt || '-'
    },
    trailer: {
      type: trailer?.type || '-',
      number: trailer?.number || '-',
      licensePlate: trailer?.licensePlate || '-',
      damage: trailer?.damage
        ? i18n.global.t('gateFeed.lists.observationList.hasDamage')
        : i18n.global.t('gateFeed.lists.observationList.noDamage'),
      hasSeal:
        trailer?.hasSeal === null
          ? '-'
          : trailer?.hasSeal
          ? i18n.global.t('gateFeed.lists.observationList.hasSeal')
          : i18n.global.t('gateFeed.lists.observationList.noSeal'),
      sealNumber: trailer?.sealNumber || '-',
      detectedAt: observation?.detectedAt || '-'
    }
  };
}

export function mapObservations(observations) {
  if (!observations || !Array.isArray(observations)) {
    return [];
  }
  observations = observations.map(observation => mapObservationData(observation));
  return observations;
}

export function mapObservation(observation) {
  if (!observation) {
    return null;
  }
  return mapObservationData(observation);
}

export function mapSortOption(sortOption) {
  const sortOptions = {
    date: 'startDate',
    time: 'startDate',
    'vehicle.licensePlate': 'licensePlate',
    'vehicle.number': 'number',
    'vehicle.carrier': 'carrierName',
    'vehicle.dotNumber': 'dotNumber',
    'vehicle.class': 'vehicleClass',
    'vehicle.fuelType': 'fuelType',
    'vehicle.damage': 'damage',
    'chassis.licensePlate': 'assetObservations.licensePlate',
    'chassis.number': 'assetObservations.number',
    'chassis.damage': 'assetObservations.damage',
    'trailer.type': 'assetObservations.assetType',
    'trailer.number': 'assetObservations.number',
    'trailer.licensePlate': 'assetObservations.licensePlate',
    'trailer.damage': 'assetObservations.damage',
    'trailer.hasSeal': 'assetObservations.hasSeal',
    'trailer.sealNumber': 'assetObservations.sealNumber'
  };

  return sortOptions[sortOption] || sortOption;
}
